
import _ from 'lodash';
import React from 'react';
import { Spinner, Container } from 'react-bootstrap';

import { useRouteMatch } from 'react-router'
import { useHistory } from "react-router-dom";
import { useImmer } from 'use-immer';
import ButtonLoading from '../../../components/ButtonLoading';
import config from '../../../constants/config';
import { JobT } from '../../../types/Job';
import { AxiosInstance } from '../../../utils/RequestMethods';
import ContactFormSubmission from '../NewJob/ContactTab/ContactFormSubmission';
import ContactPhone from '../NewJob/ContactTab/ContactPhone';
import ContactSms from '../NewJob/ContactTab/ContactSms';
import { ContactHistoryT } from '../NewJob/ContactTab/ContactTab';
import ContactTranscription from '../NewJob/ContactTab/ContactTranscription';
import { JobObj } from '../NewJob/InitObjectJob';


export type IDisputeProps = {
    job: JobT
    token: string
}

const ContactDispute: React.FC<IDisputeProps> = (props) => {
    const match = useRouteMatch()
    const history = useHistory()
    const [communicationsItems, setCommunicationsItems] = React.useState([])
    const [isReady, setIsReady] = React.useState(false);
    const [job, setJob] = React.useState<JobT | null>(JobObj);
    const [page, setPage] = React.useState(1)
    const [paginationInfo, setPaginationInfo] = useImmer({
        total: 0,
        totalPages: 0,
    });


    React.useEffect(() => {
        setJob(props.job)
        init()
    }, []);

    const init = async (): Promise<void> => {
        let j = null;
        return await getCommunications(props?.job?.id, props.token)
    }


    const getCommunications = async (jobId: number, token: string, page = 1, rest = false) => {
        let params = {
            order: "desc",
            page: page,
            token: token,
            _embed: true,
        }
        let options = {
            data: params
        }

        let url = `${config.url.jobs}/${jobId}/communications/dispute`

        return await AxiosInstance.get(`${url}`, options).then((res) => {
            if (res?.data && res?.headers['x-wp-totalpages']) {
                if (rest) {
                    setCommunicationsItems(res.data)
                } else {
                    // @ts-ignore
                    setCommunicationsItems([...communicationsItems, ...res.data])
                }
                const total = res.headers['x-wp-total']
                const totalPages = res.headers['x-wp-totalpages']
                setPaginationInfo((draft => {
                    draft.total = total
                    draft.totalPages = totalPages
                }))
            }
            setIsReady(true)
        }).catch((error) => {
            setIsReady(true)
        })
    }

    const renderContactHistory = () => {
        if (_.isArray(communicationsItems)) {
            return communicationsItems.map((item: ContactHistoryT, index) => {
                // console.log("isFirstCommunication", isFirstCommunication(communicationsItems, paginationInfo.total, index))

                switch (item.type) {
                    case "smuvsrp_quote":
                        return <ContactFormSubmission key={index} job={job} item={item} />
                    case "smuvsrp_chat":
                        return <ContactTranscription key={index} job={job} item={item} />
                    case "phone":
                        return <ContactPhone key={index} job={job} item={item}  disputeEdit/>
                    case "sms":
                        return <ContactSms key={index} job={job} item={item} disputeEdit/>
                    default:
                        return null;
                }

            })
        }
    }
    if (!isReady) {
        return (
            <Container className="mt-5 text-center">
                <Spinner animation="border" variant="info" />
            </Container>
        )
    }
    return (
        <div style={{ overflow: "hidden" }} className="mb-2 mt-2" >
            <div style={{ height: "100%", overflow: "auto", position: "relative" }}>
                {renderContactHistory()}

            </div>
            {(paginationInfo.total != 0 && paginationInfo.total > communicationsItems.length) &&
                <ButtonLoading variant='link'
                    // noShowResultMessage
                    noShowResultMessageSuccess
                    noShowResultMessageError
                    timeShowMsg={100}
                    onClickFetching={async (event): Promise<string> => {
                        let countPage = page + 1
                        setPage(countPage)
                        try {
                            let res = await getCommunications(props?.job?.id, props.token, countPage)
                            return ""
                        } catch (error) {
                            throw new Error(error)
                        }

                    }}>load more</ButtonLoading>}

        </div>
    );
}

export default ContactDispute